const Location = () => {
  return (
    <section id="localizacao" className="bg-white py-10 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="rounded-2xl overflow-hidden border border-[#F0EAE0] flex flex-col lg:flex-row">
          {/* Map */}
          <div className="w-full lg:w-2/3 h-64 md:h-80 lg:h-96">
            <iframe
              title="MG+ Saúde & Estética – Localização"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3653.2644752534!2d-46.535!3d-23.665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDM5JzU0LjAiUyA0NsKwMzInMDYuMCJX!5e0!3m2!1spt-BR!2sbr!4v1680000000000!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Info */}
          <div className="w-full lg:w-1/3 bg-[#FAF7F2] p-8 flex flex-col justify-center gap-6">
            <div>
              <span className="text-[#C4A45A] text-xs tracking-[0.3em] uppercase font-raleway block mb-2">
                Como chegar
              </span>
              <h3 className="font-cormorant text-2xl text-[#2C2B29] font-semibold">Nossa Localização</h3>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-[#C4A45A] flex-shrink-0">
                <i className="ri-map-pin-line text-base"></i>
              </div>
              <div>
                <p className="font-raleway text-sm text-[#2C2B29] font-medium">MG+ Saúde &amp; Estética</p>
                <p className="font-raleway text-sm text-[#8B8680] leading-relaxed mt-0.5">
                  Rua Primeiro de Maio, 202, Sala 601<br />
                  Centro, Santo André – SP
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white text-[#C4A45A] flex-shrink-0">
                <i className="ri-time-line text-base"></i>
              </div>
              <div>
                <p className="font-raleway text-sm text-[#2C2B29] font-medium">Horário de Atendimento</p>
                <p className="font-raleway text-sm text-[#8B8680] mt-0.5">Segunda a Sexta: 09h – 18h</p>
                <p className="font-raleway text-sm text-[#8B8680]">Sábado: 09h – 13h</p>
              </div>
            </div>

            <a
              href="https://www.google.com/maps/search/Rua+Primeiro+de+Maio+202+Santo+André+SP"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 border border-[#C4A45A] text-[#C4A45A] font-raleway text-xs tracking-[0.15em] uppercase px-6 py-3 rounded-full hover:bg-[#C4A45A] hover:text-white transition-all cursor-pointer whitespace-nowrap self-start"
            >
              <i className="ri-navigation-line"></i>
              Ver no Maps
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
